<div class="configurationBannerHeader" (click)="toggleExpansion()">
  <label class="configurationBannerLabel">Mechanical Connections</label>
  <span class="spacer"></span>
  <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
</div>
@if (!collapsed) {
  <div class="selectionsWrapper">
    <div class="configurationDetailRow">
      <div class="halfWidthConfigurationInput">
        @if (arrangementSelection) {
          <span>
            <label class="halfWidthInputLabel">Arrangement:</label>
            <select class="modConnectionField" #arrangementInput id="arrangementInput"
              [class.invalidConfigurationSelection]="isInvalidSelection(arrangementSelection.Name)"
              (change)="selectedValueChanged(arrangementSelection.Name, arrangementInput.value)"
              [value]="arrangementSelection.Value.toString()">
              @for (allowable of arrangementSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="arrangementSelection.Value && arrangementSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="halfWidthConfigurationInput">
        @if (paintOptionsSelection) {
          <span>
            <label class="halfWidthInputLabel">Paint Options:</label>
            <select class="halfWidthInputField" #paintOptionsInput
              [class.invalidConfigurationSelection]="isInvalidSelection(paintOptionsSelection.Name)"
              (change)="selectedValueChanged(paintOptionsSelection.Name, paintOptionsInput.value)"
              [value]="paintOptionsSelection.Value.toString()">
              @for (allowable of paintOptionsSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="paintOptionsSelection.Value && paintOptionsSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
    <div class="configurationDetailRow">
      <div class="halfWidthConfigurationInput">
        @if (returnAirSelection) {
          <span>
            <label class="halfWidthInputLabel">Return Air:</label>
            <select class="halfWidthInputField" #returnAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(returnAirSelection.Name)"
              (change)="selectedValueChanged(returnAirSelection.Name, returnAirInput.value)"
              [value]="returnAirSelection.Value.toString()">
              @for (allowable of returnAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="returnAirSelection.Value && returnAirSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="halfWidthConfigurationInput">
        @if (wallMountSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(wallMountSelection.Name)"
            for="wallMountInput" class="halfWidthInputLabel">Wall Mount:</label>
            <input type="checkbox" class="checkboxInput" id="wallMountInput"
              #wallMountInput [checked]="'true' === wallMountSelection.Value"
              (change)="selectedValueChanged(wallMountSelection.Name, wallMountInput.checked.toString())">
          </span>
        }
      </div>
    </div>
    <div class="configurationDetailRow">
      <div class="halfWidthConfigurationInput">
        @if (supplyAirSelection) {
          <span>
            <label class="halfWidthInputLabel">Supply Air:</label>
            <select class="halfWidthInputField" #supplyAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(supplyAirSelection.Name)"
              (change)="selectedValueChanged(supplyAirSelection.Name, supplyAirInput.value)"
              [value]="supplyAirSelection.Value.toString()">
              @for (allowable of supplyAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="supplyAirSelection.Value && supplyAirSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
      <div class="halfWidthConfigurationInput">
        @if (rearDecoPanelSelection) {
          <span>
            <label [class.invalidConfigurationSelection]="isInvalidSelection(rearDecoPanelSelection.Name)"
            for="rearDecoPanelInput" class="halfWidthInputLabel">Rear Deco Panel:</label>
            <input type="checkbox" class="checkboxInput" id="rearDecoPanelInput"
              #rearDecoPanelInput [checked]="'true' === rearDecoPanelSelection.Value"
              (change)="selectedValueChanged(rearDecoPanelSelection.Name, rearDecoPanelInput.checked.toString())">
          </span>
        }
      </div>
    </div>
    <div class="configurationDetailRow">
      <div class="halfWidthConfigurationInput">
        @if (outsideAirSelection) {
          <span>
            <label class="halfWidthInputLabel">Outside Air:</label>
            <select class="halfWidthInputField" #outsideAirInput
              [class.invalidConfigurationSelection]="isInvalidSelection(outsideAirSelection.Name)"
              (change)="selectedValueChanged(outsideAirSelection.Name, outsideAirInput.value)"
              [value]="outsideAirSelection.Value.toString()">
              @for (allowable of outsideAirSelection.Allowables; track allowable) {
                <option
                  [class.invalidSelectorValue]="!allowable.IsValid" class="configurationSelectionOption"
                  [selected]="outsideAirSelection.Value && outsideAirSelection.Value.toString() === allowable.Value"
                [value]="allowable.Value">{{ allowable.Description }}</option>
              }
            </select>
          </span>
        }
      </div>
    </div>
    <div class="configurationDetailRow">
      @if (handArrangementImagePath() && handArrangementImagePath().length > 0) {
        <img class="handArrangementImage"
          [src]="handArrangementImagePath()" alt="ArrangementImage"/>
      }
    </div>
  </div>
}
